/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { getNestedValue as i } from "./misc.mjs";
class h {
  constructor(e) {
    this.expandField = e.expandField, this.selectField = e.selectField, this.hasChildrenField = e.hasChildrenField, this.childrenField = e.childrenField, this.textField = e.textField, this.disableField = e.disableField, this.checkField = e.checkField, this.checkIndeterminateField = e.checkIndeterminateField, this.focusIdField = e.focusIdField;
  }
  expanded(e) {
    return i(this.expandField, e);
  }
  selected(e) {
    return i(this.selectField, e);
  }
  text(e) {
    return i(this.textField, e);
  }
  disabled(e) {
    return i(this.disableField, e);
  }
  hasChildren(e) {
    return i(this.hasChildrenField, e);
  }
  children(e) {
    const d = i(this.childrenField, e);
    return d || [];
  }
  checked(e) {
    return i(this.checkField, e);
  }
  checkIndeterminate(e) {
    return i(this.checkIndeterminateField, e);
  }
  focusId(e) {
    return this.focusIdField && i(this.focusIdField, e);
  }
  getChildrenField() {
    return this.childrenField;
  }
}
export {
  h as TreeFieldsService
};
